import { useAccountStore } from '@/store';
import { Account } from '@/types';
import { useMutation, useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/types/queryKey';
import {
  createAccount,
  getAccount,
  logInAccount,
  refreshAccessToken,
} from '@/lib/services';
import { setAccessToken } from '@/lib/utils/auth';
import { useAxiosErrorHandler } from '@/hooks/common';

export function useSignUp() {
  return useMutation({
    mutationFn: createAccount,
  });
}

export function useSignIn() {
  return useMutation({
    mutationFn: logInAccount,
  });
}
export function useRefreshAccount() {
  const setAccount = useAccountStore((state) => state.setAccount);
  const { parseAndShowError } = useAxiosErrorHandler();

  return useMutation({
    mutationFn: refreshAccessToken,
    retry: (_failureCount, error) => {
      parseAndShowError(error);
      return false;
    },
    onSuccess: (data) => {
      const accountData = data.data as Account;
      setAccount(accountData);

      const newAccessToken = accountData.token;
      const newAccessTokenExpires = accountData.token_expires;

      setAccessToken(newAccessToken, newAccessTokenExpires);
    },
  });
}

export function useAccount() {
  return useQuery({
    queryKey: [QueryKey.Account],
    queryFn: getAccount,
  });
}
